export default "__VITE_ASSET__4fb9537a__"